import {
  Composite,
  CompositeItem,
  useCompositeState,
  useTooltipState,
  TooltipReference,
  TooltipReferenceProps,
} from 'reakit';
import { useState, MouseEvent } from 'react';
import { Star, StarProps } from './Star';
import { Tooltip } from './Tooltip';
import { Box } from '../../Box/Box';

export type StarsProps = {
  selectedRating?: number;
  onRatingChange(
    rating: Exclude<StarsProps['selectedRating'], undefined>
  ): void;
};

let ratings = ['Ужасно', 'Плохо', 'Нормально', 'Хорошо', 'Отлично'];

type CompositeStarProps = StarProps & {
  label: string;
};

function CompositeStar({ label, ...props }: CompositeStarProps) {
  let tooltip = useTooltipState();
  return (
    <>
      <TooltipReference {...tooltip}>
        {(tooltipProps: TooltipReferenceProps) => (
          <CompositeItem
            {...props}
            {...tooltipProps}
            aria-describedby={undefined}
            as={Star}
            aria-label={label}
            onMouseEnter={(event: MouseEvent) => {
              tooltipProps.onMouseEnter?.(event);
              props.onMouseEnter?.(event);
            }}
          />
        )}
      </TooltipReference>
      <Tooltip {...tooltip}>{label}</Tooltip>
    </>
  );
}

export function Stars({
  onRatingChange,
  selectedRating,
  ...props
}: StarsProps): JSX.Element {
  let [potentiallySelected, setPotentiallySelected] = useState<number>(
    selectedRating || 0
  );
  let composite = useCompositeState();
  return (
    <Composite
      as={Box}
      display="flex"
      {...composite}
      onMouseLeave={() => {
        setPotentiallySelected(0);
      }}
      {...props}
    >
      {ratings.map((label, index) => (
        <CompositeStar
          {...composite}
          rating={index + 1}
          // eslint-disable-next-line react/no-array-index-key -- некритично
          key={index}
          label={label}
          align-self={['stretch', 'flex-start']}
          aria-pressed={index + 1 === selectedRating}
          selectedRating={Math.max(selectedRating || 0, potentiallySelected)}
          onMouseEnter={() => setPotentiallySelected(index + 1)}
          onClick={() => onRatingChange(index + 1)}
          styles={{
            mr: ['sp-8', 'sp-4'],
            '&:last-child': { mr: ['sp-0'] },
          }}
        />
      ))}
    </Composite>
  );
}
